import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

// Licenciamento por assento (sistemas 10.9+): cada registro e uma chave de instalacao
// e o servidor que a usou. Gerar chave, revogar/cancelar e desbloquear clone; a API
// nao tem insert/update generico.
class LicencaService extends BaseService {
  constructor() {
    super(`${ConfigApi.licencaURL}`);
  }

  getFilter() {
    return new Filter();
  }

  // devolve a chave EM CLARO uma unica vez (o portal guarda so o hash)
  async gerarChave(numeroContrato) {
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/chave`, { numeroContrato });
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  // ativa -> revogada; chave nao usada -> cancelada
  async revogar(id, motivo) {
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/${id}/revogar`, { motivo });
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  // zera a contagem de clone do CONTRATO (nao de uma instalacao)
  async desbloquear(idCliente, motivo) {
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/desbloquear/${idCliente}`, { motivo });
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }
}

class Filter {
  constructor() {
    this.numeroContrato = '';
    this.situacao = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new LicencaService();
